"use client";

import { useEffect, useState } from "react";
import dynamic from "next/dynamic";
const IntercomChat = dynamic(() => import( /* webpackChunkName: "IntercomChat" */"services/intercom/IntercomChat"), {
  ssr: false
});
const DeferredIntercomChat = () => {
  const [shouldLoad, setShouldLoad] = useState(false);
  useEffect(() => {
    if (shouldLoad || typeof window === "undefined") {
      return;
    }
    const triggerLoad = () => {
      setShouldLoad(true);
    };
    window.addEventListener("pointerdown", triggerLoad, {
      once: true,
      passive: true
    });
    window.addEventListener("touchstart", triggerLoad, {
      once: true,
      passive: true
    });
    window.addEventListener("keydown", triggerLoad, {
      once: true
    });
    return () => {
      window.removeEventListener("pointerdown", triggerLoad);
      window.removeEventListener("touchstart", triggerLoad);
      window.removeEventListener("keydown", triggerLoad);
    };
  }, [shouldLoad]);
  return shouldLoad ? <IntercomChat data-sentry-element="IntercomChat" data-sentry-component="DeferredIntercomChat" data-sentry-source-file="DeferredIntercomChat.tsx" /> : null;
};
export default DeferredIntercomChat;